import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getSearchableFields } from '~/components/SearchV2/utils';
import BaseSaveView from '~/components/Shared/BaseSaveView/BaseSaveView';
import { TableViewContextType } from '~/enums/TableViewType';
import { slices } from '~/redux/slices';

const GroupDocumentsSaveView = () => {
  const modal = useSelector(slices.documentGroup.selectors.selectModal);
  const columnOrder = useSelector(
    slices.documentGroup.selectors.selectColumnOrder,
  );
  const dispatch = useDispatch();
  const hideModal = () => dispatch(slices.documentGroup.actions.setModal());
  const { modalType } = modal || {};

  const fields = getSearchableFields(columnOrder);

  return (
    <BaseSaveView
      context={TableViewContextType.GROUP}
      fields={fields}
      hideModal={hideModal}
      modalType={modalType}
    />
  );
};

export default GroupDocumentsSaveView;
